// extracted by mini-css-extract-plugin
export default {"app":"AuthLayout_app__nY6aR","app-container":"AuthLayout_app-container__DPNtc","logo":"AuthLayout_logo__ODFCr","form-container":"AuthLayout_form-container__Ja95f"};